export const RESET = 'USER_LIST_RESET'
export const SET_ITEMS = 'USER_LIST_SET_ITEMS'
export const SET_ERROR = 'USER_LIST_SET_ERROR'
export const SET_VIEW = 'USER_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'USER_LIST_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/user/list/mutation_types.js